import type * as React from 'react'

import { cn } from '@/lib/utils'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-neutral-200 animate-pulse motion-reduce:animate-none', className)}
      {...props}
    />
  )
}

export { Skeleton }
